import { signOut as firebaseSignOut, getAuth } from 'firebase/auth';

import loginWithFacebook from './facebookLogin';
import loginWithGoogle from './googleLogin';

const auth = getAuth();
const signOut = () => firebaseSignOut(auth);

const firebase = {
  loginWithFacebook,
  loginWithGoogle,
  auth,
  signOut
};

export default firebase;